import { signInWithEmailAndPassword } from "firebase/auth";
import { auth } from "@/lib/firebase";
import { apiClient } from "@/lib/api-client";
import type { ApiResponse, LoginRequest, User } from "@/types/api";

/**
 * Sign in via Firebase. The backend `User` record is loaded separately by
 * `AuthContext.onAuthStateChanged` → `getCurrentUser()`.
 */
export async function login(data: LoginRequest): Promise<void> {
  await signInWithEmailAndPassword(auth, data.email, data.password);
}

/** Get the current authenticated user profile from the backend. */
export async function getCurrentUser(): Promise<ApiResponse<User>> {
  const response = await apiClient.get<ApiResponse<User>>("/auth/me");
  return response.data;
}

/** Change the current user's password. */
export async function changePassword(
  currentPassword: string,
  newPassword: string,
): Promise<void> {
  const response = await apiClient.post<ApiResponse<null>>(
    "/auth/change-password",
    {
      currentPassword,
      newPassword,
    },
  );
  if (!response.data.success) {
    throw new Error(response.data.message || "Failed to change password");
  }
}
